import {
	BbcBusDesktopIllustration,
	BbcBusMobileIllustration,
	BbcDesktopIllustration,
	BbcMobileIllustration,
} from "@obs/icons";
import { breakpoints, measure } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";

import { Wrapper } from "../primitives/Wrapper";

type WebHeaderProps = {
	slotEnd?: ReactNode;
	variant?: "default" | "bus";
};

const styles = stylex.create({
	logo: {
		blockSize: "100%",
	},
	mobile: {
		height: measure.sizeL,
		display: {
			default: "block",
			[breakpoints.md]: "none",
		},
	},
	desktop: {
		height: measure.sizeL,
		display: {
			default: "none",
			[breakpoints.md]: "block",
		},
	},
	spacer: {
		flex: 1,
	},
	slotEnd: {
		display: "flex",
		gap: measure.sizeL,
	},
});

export const Web = ({ slotEnd, variant = "default" }: WebHeaderProps) => {
	const MobileLogo = variant === "bus" ? BbcBusMobileIllustration : BbcMobileIllustration;
	const DesktopLogo = variant === "bus" ? BbcBusDesktopIllustration : BbcDesktopIllustration;

	return (
		<Wrapper>
			<div {...stylex.props(styles.mobile)}>
				<MobileLogo {...stylex.props(styles.logo)} />
			</div>
			<div {...stylex.props(styles.desktop)}>
				<DesktopLogo {...stylex.props(styles.logo)} />
			</div>
			<div {...stylex.props(styles.spacer)} />
			<div {...stylex.props(styles.slotEnd)}>{slotEnd}</div>
		</Wrapper>
	);
};
